import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { getSearchValue, setSearchValue } from '@/stores/slices/modelsState';
import { Button, Icon } from '../index';

import './input.scss';
import { hideShort } from '@/stores/slices/showFilterSlice';
import { useTranslation } from 'react-i18next';
import useLadyService from '@/services/LadyService';
import {
	cleanSorted,
	setSortedModelsByFilter,
} from '../../../stores/slices/modelsState';
import { useFilterLogicContext } from '@/components/filter/FilterLogicProvider';
import { useNavigate } from 'react-router-dom';

const InputNick = (props) => {
	const {
		type,
		placeholder,
		id,
		clazz,
		autocomplete = 'off',
		name,
		scrolledClass = '',
	} = props;

	const { windowWidth, dispatch, scrollToTop } = useLadyService();
	const FILTER = useFilterLogicContext();

	const { t } = useTranslation('translation');

	const searchValue = useSelector(getSearchValue);

	const [value, setValue] = useState(searchValue);

	useEffect(() => {
		setValue(searchValue);
	}, [searchValue]);

	useEffect(() => {
		if (!searchValue) {
			setValue('');
		}
	}, [searchValue]);

	const handleChange = (e) => {
		const value = e.target.value;
		setValue(value);
	};
	
	const navigate = useNavigate()
	const handleSearchClick = (e) => {
		navigate('/')
		e.stopPropagation();
		e.preventDefault();
		scrollToTop(100);

		FILTER.resetFilter(false);

		dispatch(setSearchValue(value));
		dispatch(hideShort());
	};

	const handleKeyDown = (event) => {
		if (event.key === 'Enter') {
			handleSearchClick(event);
		}
		if (event.key === 'Escape') {
			setValue('');
			dispatch(setSearchValue(''));
			dispatch(hideShort());
		}
	};

	useEffect(() => {
		return () => {
			setValue('');
		};
	}, []);

	return (
		<div className="search">
			<label
				htmlFor={id}
				className="search__label header__search--label"
			>
				<input
					autoComplete={autocomplete}
					className={`search__input ${clazz ? clazz : ''}`}
					type={type}
					name={name}
					placeholder={placeholder}
					value={value}
					onChange={handleChange}
					onKeyDown={handleKeyDown}
					id={id}
				/>

				{/* <Button
          size={"xs"}
          clazz="search__icon"
          onClick={() => handleClick()}
        >
          <Icon size={"m"} spritePath={"search"} />
        </Button> */}
			</label>
			{value && (
				<Button
					title={t('reset')}
					onClick={() => {
						setValue('');
						dispatch(setSearchValue(null));
						dispatch(hideShort());
					}}
					clazz="search__close"
				>
					<Icon
						size={'m'}
						spritePath={'close'}
					/>
				</Button>
			)}
			<Button
				clazz="search__icon inputnick_search button--green__secondary"
				onClick={handleSearchClick}
			>
				<Icon
					size={'m'}
					spritePath={'search'}
				/>
			</Button>
		</div>
	);
};

export default InputNick;
